import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table";
import {
  timestampFormatter,
  LOCAL_DATE_TIME_FORMAT,
  TIMESTAMP,
} from "@/react/datetime";
import { getColumnDef } from "@/react/schema/schemaFields";

import schema from "./schema";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      {
        ...getColumnDef(schema.fields.blfId, "BLF ID"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.branchId, "Branch ID"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields["Branch Name"], "Branch Name"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.name, "PBX"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.deviceId, "Device ID"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.deviceBindingId, "Binding ID"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.extensionNumber, "Extension"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.destination, "Destination"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.customerId, "Customer ID"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.label, "Label"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.enablePickup, "Enable Pickup"),
        type: TYPES.BOOLEAN,
      },
      {
        ...getColumnDef(schema.fields.lastUpdatedTime, "Last Updated Time"),
        type: TYPES.UNIX_TIMESTAMP,
        timestampFormatter: timestampFormatter(
          TIMESTAMP.UNITS.SECONDS,
          TIMESTAMP.ZONE.LOCAL,
          LOCAL_DATE_TIME_FORMAT
        ),
        timestampUnit: TIMESTAMP.UNITS.SECONDS,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
